import { render, staticRenderFns } from "./20.vue?vue&type=template&id=4c68f572&scoped=true&"
var script = {}
import style0 from "./20.vue?vue&type=style&index=0&id=4c68f572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68f572",
  null
  
)

export default component.exports